import { useDispatch } from "react-redux";
import { setToast, TToastTypeState } from "../store/mapScreenSlce";

function useToastMap() {
    const dispatch = useDispatch();

    function openToastMap(type: TToastTypeState, text: string) {
        dispatch(setToast({ text, type, visible: true }));
    }

    function hideToastMap(){
        dispatch(setToast({ text: '', type: 'loading', visible: false }));
    }

    return ({
        openToastMap,
        hideToastMap
    })
}

export default useToastMap;